import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'; // NB: To support unveiling e.g. <script>-tags

document.addEventListener('lazybeforesizes', (event) => {
  const image = event.target;

  let parsedImageSrc;
  const calculatedSizes = event.detail.width;
  const imageWidth = image.clientWidth;
  let approximatedSize = Math.min(imageWidth, calculatedSizes);

  if (image.dataset.lazysizesComputeWidthAdhoc === 'true') {
    const ratio = image.clientWidth / image.clientHeight;
    const useSquareImage = ratio < 1.4; // The uploaded image is 16/9 (1.778) so we use the square version for everything below a 1.4 image ratio
    const usePortraitImage = ratio < 0.75;

    if (useSquareImage || usePortraitImage) {
      let ar = '1:1';
      if (usePortraitImage) ar = '1:2';

      if (image.dataset.focalpoint) {
        image.dataset.src = `${image.dataset.src}&mode=crop&crop=focalpoint&fp-x=${image.dataset.focalpoint}&ar=${ar}`;
      } else {
        image.dataset.src = `${image.dataset.src}&mode=crop&ar=${ar}`;
      }
    }
  }

  try {
    parsedImageSrc = new URL(image.dataset.src);
  } catch {
    // If there is no URL (pointing to our image proxy) we cannot set the `w`-query param
    return;
  }

  let sizes = [];
  [1, 1.5, 2].forEach((dpr) => {
    const dprSize = Math.ceil(approximatedSize * dpr);
    parsedImageSrc.searchParams.set('w', dprSize);
    sizes.push(`${parsedImageSrc.toString()} ${dprSize}w`);
  });
  image.dataset.srcset = sizes.join(', ');
  event.detail.width = approximatedSize;
  // }
});
